"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _ajax_1 = __importDefault(require("./_ajax"));
var _form_handler_1 = __importDefault(require("./_form-handler"));
(function ($) {
    (0, _ajax_1.default)($);
    //TODO: Move to common modules
    (0, _form_handler_1.default)($);
})(jQuery);
